export default "__VITE_ASSET__CAdffj73__"